<div class="row">
  <h3>
    {{ "account.pin-change.title" | translate }}
  </h3>
</div>
<div class="row disclaimer">
  <div class="caption">
    <small>
      {{ "account.pin-change.disclaimer" | translate }}
    </small>
  </div>
</div>
<form [formGroup]="passwordForm" (ngSubmit)="submitPinChange()">
  <div class="row input current-pin">
    <div class="content">
      <input
        type="password"
        class="input"
        [placeholder]="'account.pin-change.form.current-pin' | translate"
        formControlName="password"
      />
    </div>
  </div>
  <div class="row input">
    <div class="content">
      <input
        type="password"
        class="input"
        [class.error]="
          passwordForm.dirty &&
          passwordForm.get('newPassword').dirty &&
          passwordForm.get('newPassword').errors && (passwordForm.get('newPassword').errors.tooShort || passwordForm.get('newPassword').errors.tooLong || passwordForm.get('newPassword').errors.insecure) ||
          passwordForm.errors && passwordForm.errors.notMatching
        "
        [placeholder]="'account.pin-change.form.new-pin' | translate"
        formControlName="newPassword"
      />
    </div>
  </div>
  <div class="row input new-pin-repeat">
    <div class="content">
      <input
        type="password"
        class="input"
        [class.error]="passwordForm.dirty &&
          passwordForm.get('newPasswordRepeat').dirty && passwordForm.errors && passwordForm.errors.notMatching"
        [placeholder]="'account.pin-change.form.new-pin-repeat' | translate"
        formControlName="newPasswordRepeat"
      />
    </div>
  </div>
  <div class="row controls" *ngIf="passwordForm.valid; else passwordSecurity">
    <button type="submit" class="btn" [disabled]="!passwordForm.valid">
      <span>
        {{ "account.pin-change.controls.save" | translate }}
      </span>
    </button>
  </div>
  <ng-template #passwordSecurity>
    <div class="row">
      <app-password-security
        *ngIf="passwordForm.get('newPassword').value"
        [password]="passwordForm.get('newPassword').value"
      ></app-password-security>
    </div>
  </ng-template>
  <div class="row form-error">
    <div class="caption" *ngIf="passwordForm">
      <ng-container
        *ngIf="
          passwordForm.dirty &&
          passwordForm.get('newPassword').errors;
          else pinValid
        "
      >
        <small *ngIf="passwordForm.get('newPassword').dirty && passwordForm.get('newPassword').errors.tooShort">
          {{  'account.pin-change.form.errors.tooShort' | translate }}
        </small>
        <small *ngIf="passwordForm.get('newPassword').dirty && passwordForm.get('newPassword').errors.tooLong">
          {{  'account.pin-change.form.errors.tooLong' | translate }}
        </small>
        <small *ngIf="passwordForm.get('newPassword').dirty && passwordForm.get('newPassword').errors.insecure">
          {{  'account.pin-change.form.errors.insecure' | translate }}
        </small>
      </ng-container>
      <ng-template #pinValid>
        <small *ngIf="passwordForm.errors">
          {{
            "account.pin-change.form.errors." +
              (passwordForm.errors | keyvalue)[0].key | translate
          }}
        </small>
      </ng-template>
    </div>
  </div>
</form>
